import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ContentSection from 'components/ContentSection';

function Banner(_ref) {
  var id = _ref.id,
      slot = _ref.slot,
      isSticky = _ref.isSticky;
  var location = useLocation();
  useEffect(function () {
    window.dispatchEvent(new CustomEvent('bn-slot-display', {
      detail: {
        'bn-slots': [slot]
      }
    }));
  }, [location.pathname]);
  return /*#__PURE__*/_jsx(ContentSection, {
    style: {
      padding: 0
    },
    sticky: isSticky
  }, void 0, /*#__PURE__*/_jsx("div", {
    id: id,
    "data-bn-slot": slot
  }));
}

Banner.defaultProps = {
  isSticky: false
};
export default /*#__PURE__*/memo(Banner);